
export class MapLibreGLUtils {
    static getLayerName(name: string): string {
        return `${name}-layer`;
    }

    static getFillLayerName(name: string): string {
        return `${name}-fill-layer`;
    }
}